<ng-container *transloco="let t; prefix: scope">
  <div class="bg-blue-5 flex flex-wrap items-center justify-between gap-3 border-b border-steel-10 px-4 py-3">
    <h2 class="m-0 text-heading-3">{{ t('title') }}</h2>

    <mat-form-field class="w-56 bg-white" appearance="outline" subscriptSizing="dynamic">
      <mat-label>{{ t('markerType.label') }}</mat-label>
      <mat-select
        [value]="store.markerType()"
        (selectionChange)="store.setMarkerType($event.value)"
        data-id="compare-agents-map-marker-type"
      >
        @for (markerType of markerTypes; track markerType) {
          <mat-option [attr.data-id]="'compare-agents-map-marker-type-' + markerType" [value]="markerType">
            {{ t('markerType.' + (markerType | lowercase)) }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <rma-agent-toggle-row class="border-b border-steel-10 px-4 py-3" [agents]="store.toggles()" (toggled)="store.toggle($event)" />

  @if (gated()) {
    <img alt="" class="block h-96 w-full object-cover" [src]="previewImageUrl" loading="lazy" data-id="compare-agents-map-preview" />
  } @else {
    @defer (on viewport) {
      <div #mapArea class="relative h-96">
        @if (store.initialising()) {
          <rma-skeleton-grid class="absolute inset-0 p-4" [bones]="1" heightClass="h-full" data-id="compare-agents-map-loading" />
        } @else if (!store.failed()) {
          <rma-google-map
            class="block h-full"
            [options]="options"
            [markers]="store.visibleMarkers()"
            [activeMarker]="store.activeMarker()"
            [resetBounds]="store.resetBounds()"
            [profileType]="profileType"
            [profileCode]="store.activeAgentCode()"
            (boundsSet)="onBoundsChanged($event)"
            (markerSelected)="store.selectMarker($event)"
            (markerDeselected)="store.deselectMarker($event)"
          >
            @if (store.loading()) {
              <div class="absolute bottom-0 left-0 flex w-full justify-center py-2" data-id="compare-agents-map-loading">
                <div class="rounded-lg bg-white p-2 drop-shadow-lg">
                  <mat-spinner color="primary" diameter="20" />
                </div>
              </div>
            }
          </rma-google-map>
        }

        @if (store.empty() || store.failed()) {
          <div class="pointer-events-none absolute inset-0 flex items-center justify-center p-4">
            <rma-callout [message]="t('empty')" calloutType="error" data-id="compare-agents-map-empty" />
          </div>
        }
      </div>
    } @placeholder {
      <rma-skeleton-grid class="block h-96 p-4" [bones]="1" heightClass="h-full" data-id="compare-agents-map-placeholder" />
    }
  }
</ng-container>
